var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pending-join-request-data-table',{attrs:{"allupcomingparticipants":_vm.allupcomingparticipants}})
}
var staticRenderFns = []

export { render, staticRenderFns }